import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'ui/Button';

import { UsersTable } from 'modules/AdminUsers/UsersTable';

import { PAGES } from 'utils/link';
import { QueryHelper } from 'utils/helpers';
import { QUERY_PARAMS } from 'utils/constants';

import styles from 'assets/scss/modules/AdminUsers/AdminUsers.module.scss';

export const AdminUsers: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateUser = () => {
    navigate(
      PAGES.USER_CREATE +
        QueryHelper.getQueryString({
          [QUERY_PARAMS.STEP]: 1,
        }),
    );
  };

  return (
    <div className={styles.page}>
      <section className={styles.card}>
        <div className={styles.cardHeader}>
          <h1 className={styles.title}>Users listing</h1>

          <Button
            size="small"
            className={styles.addUserButton}
            onClick={handleCreateUser}
          >
            Add new user
          </Button>
        </div>

        <UsersTable />
      </section>
    </div>
  );
};
